export class SchemaRegistryAuthConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SchemaRegistryAuthType",
            "format": ""
        },
        {
            "name": "credentialsSecret",
            "baseName": "credentialsSecret",
            "type": "SchemaRegistryAuthConfigInputCredentialsSecret",
            "format": ""
        },
        {
            "name": "tlsSecret",
            "baseName": "tlsSecret",
            "type": "KafkaSecurityConfigInputTlsSecret",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryAuthConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
